import { render } from "./list.vue?vue&type=template&id=0a0c854a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=0a0c854a&lang=css"
import "./list.vue?vue&type=style&index=1&id=0a0c854a&scoped=true&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0c854a"]])

export default __exports__